import React from 'react';
import {useDispatch} from 'react-redux';
import {Options} from 'react-toast-notifications';
import {action} from 'redux/helpers';
import {PUSH_TOAST} from './redux/types';

export const useToasts = () => {
   const dispatch = useDispatch();
   const addToast = React.useCallback(
      (content: React.ReactNode, options?: Options) => {
         dispatch(
            action(PUSH_TOAST, {
               level: options?.appearance,
               message: content,
               ...options,
            })
         );
      },
      [dispatch]
   );

   return {
      addToast,
   };
};
